export const TAP2MINE_REFERRAL_SS_KEY = 'TAP2MINE_REFERRAL_KEY';
export const REFERRAL_QUERY_KEY = 'ref';
